import { render } from "./errorpage.vue?vue&type=template&id=33708ed4"
import script from "./errorpage.vue?vue&type=script&lang=js"
export * from "./errorpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__